(function () {
  function init() {
    document.querySelectorAll("[data-subcategories-trigger]").forEach((box) => {
      if (box.dataset.subcategoriesBound) return;
      box.dataset.subcategoriesBound = "true";

      const dialog = document.getElementById(box.dataset.subcategoriesTrigger);
      if (!dialog) return;

      box.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          dialog.showModal();
          document.documentElement.classList.add("subcategories-popup-open");
        });
      });
    });

    document.querySelectorAll("dialog.subcategories-popup").forEach((dialog) => {
      if (dialog.dataset.subcategoriesBound) return;
      dialog.dataset.subcategoriesBound = "true";

      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog
        .querySelector("[data-subcategories-close]")
        ?.addEventListener("click", () => dialog.close());

      dialog.addEventListener("close", () => {
        document.documentElement.classList.remove("subcategories-popup-open");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
